import PersonalOffer from './PersonalOffer'

export { PersonalOffer }

export default PersonalOffer
